// extracted by mini-css-extract-plugin
module.exports = {"modal":"UnselectedModal_style_modal__R6GE1","label":"UnselectedModal_style_label__3blQs","modalItem":"UnselectedModal_style_modalItem__1VC72"};